import React, { Component, Fragment } from 'react';
import '../../assets/style/itemStyle/common.scss';
import Footer from '../../components/layout/Footer';
import { marketingEmail } from '../../untils/constant/email';

export default class MembershipPolicy extends Component {
  render() {
    return (
      <Fragment>
        <div className="membership-policy">
          <b style={{ display: 'flex', 'justify-content': 'center' }}>MEMBERSHIP AGREEMENT</b>
          <br />
          <br />
          <b>Last Updated: September 16, 2022</b>
          <br />
          <br />
          <span>AIRACER MEMBERSHIP:</span> This Membership Agreement (this “<b>Agreement</b>”) with
          Airacer Inc (<b>“Airacer”</b>) governs the Jet Card membership services provided by
          Airacer (the <b>“Services”</b>). The Services provided shall be pursuant to the membership
          subscription selected by you and described in further detail in <span>Exhibit A</span>{' '}
          attached to this Agreement. Flight services and ground transportation is provided via
          third-party Operators (<b>“Operators”</b>) and by participating in any such third-party
          services you may also be bound by such Operators’ terms and conditions. <br />
          <br />
          <span>TERM:</span> The term of your Agreement will begin on the{' '}
          <b>Membership Start Date</b>, set forth above, and shall continue until the date that the
          Agreement expires or is earlier terminated, subject to the early termination of this
          Agreement as provided herein. The expiration date of this Agreement, subject to renewal or
          extension, shall be for the duration of the <b>Subscription Period</b> set forth above.
          The Agreement will automatically renew for the same <b>Subscription Period Term</b> stated
          above, unless a thirty (30) day written notice of cancellation is provided prior to the
          commencement of the renewal term. <br />
          <br />
          <span>PAYMENTS:</span> All payments shall be automatically drawn by Airacer in accordance
          with the <b>Payment Frequency</b> set forth above. The payments shall be made by either
          the Member or any Payment Responsible Party stated above. The Responsible Party shall
          complete an ACH/Payment Authorization Form provided by Airacer. <br />
          <br />
          <span>CANCELLATION:</span> Unless otherwise specified in this Agreement, and effective no
          earlier than the expiration of the Initial Term End Date, Member may cancel Member’s
          membership and terminate this Agreement by providing written notice to Airacer.
          Cancellation received between the first and the last day of the month will be effective
          upon the next month’s billing cycle. Member shall email such cancellation notice to{' '}
          <a
            href={`mailto:${marketingEmail}`}
            style={{ 'text-decoration': 'underline', color: 'rgb(5,99,193)' }}
          >
            {marketingEmail}
          </a>
          . Member’s account must be current and in good standing before Airacer will process any
          such request to cancel. You acknowledge and agree that you will forfeit any prepaid fees
          made prior to the cancellation date. All fees paid are non-refundable. <br />
          <br />
          <span>PAYMENT DEFAULT:</span> If Member fails to pay any amount owed by Member (or
          Responsible Party) fails to pay Member’s monthly dues per the Agreement) when due under
          this Agreement, as applicable, then Airacer shall be entitled, at any time in its sole
          discretion, to suspend or cancel Member’s membership and terminate this Agreement and to
          require the Responsible Party to immediately pay all past due balances owed. Suspension or
          cancellation shall not relieve the Responsible Party from the obligation to pay any unpaid
          balances owed. Any payments owing to Airacer that are not received when due shall bear
          interest at the highest rate permitted by law. Failure to pay any amounts owed to Airacer
          when due, the responsible party shall pay all costs and expenses of collection incurred by
          Airacer, including reasonable attorney’s fees and expenses. <br />
          <br />
          <span>REFUSAL OF SERVICES:</span> You acknowledge and agree that Operators providing
          services to Member, may refuse to transport or remove a Member/passenger from an aircraft
          or vehicle for any reason, including, but not limited to: (a) failure to comply with this
          Agreement or Operator’s instruction in general; (b) disorderly, disruptive, abusive,
          threatening, or conduct; (c) appearance that a passenger is intoxicated or under the
          influence of alcohol drugs; or (d) the appearance that a passenger is engaged in illegal
          activity. <br />
          <br />
          <span>THIRD PARTY SERVICES:</span> Airacer does not warrant, endorse, guarantee, or assume
          responsibility for any product or service advertised or offered by a third party through
          the Services, and Airacer shall not be a party to or in any way monitor any transaction
          between a Member and third-party providers of products or services. <br />
          <br />
          <span>DISCLAIMER OF WARRANTIES:</span> EXCEPT AS OTHERWISE SET FORTH HEREIN, THE SERVICES
          ARE PROVIDED TO PROVIDER STRICTLY ON AN “AS IS” AND “AS AVAILABLE” BASIS WITH ALL FAULTS.
          ALL CONDITIONS, REPRESENTATIONS AND WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY OR
          OTHERWISE, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS
          FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT, ARE HEREBY DISCLAIMED BY AIRACER TO THE
          MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW. YOU ACKNOWLEDGE AND AGREE THAT THE ENTIRE RISK
          ARISING OUT OF YOUR USE OF THE SERVICES, AND ANY THIRD-PARTY SERVICES OR PRODUCTS REMAINS
          SOLELY WITH YOU, TO THE MAXIMUM EXTENT PERMITTED BY LAW. THE SERVICES MAY BE SUBJECT TO
          LIMITATIONS, DELAYS, AND OTHER ISSUES. YOU ACKNOWLEDGE AND AGREE THAT AIRACER IS NOT
          RESPONSIBLE FOR ANY DELAYS, DELIVERY FAILURES, OR OTHER DAMAGE RESULTING FROM SUCH ISSUES.
          Certain jurisdictions do not allow the exclusion and limitations of certain implied
          warranties, therefore, some of the above exclusions may not apply to you. This Agreement
          gives Members specific legal rights, and Members may also have other rights which vary
          from state to state. The disclaimers and exclusions under this Agreement shall not apply
          to the extent prohibited by applicable law. <br />
          <br />
          <span>LIMITATION OF LIABILITY:</span> EXCEPT IN CASES OF AIRACER’S GROSS NEGLIGENCE,
          AIRACER IS NOT RESPONSIBLE OR LIABLE TO MEMBER FOR ANY LOSS, INJURY, EXPENSE, DAMAGE TO
          PROPERTY OR PERSONAL SICKNESS, INJURY, OR DEATH WHICH RESULTS FROM OR DURING A FLIGHT, OR
          ANY OTHER THIRD-PARTY SERVICE. NOTWITHSTANDING THE FOREGOING, AIRACER DOES NOT PROVIDE
          TRANSPORTATION SERVICES AND IS NOT A DIRECT AIR CARRIER. AIRACER OFFERS INFORMATION AND A
          METHOD TO OBTAIN THIRD-PARTY TRANSPORTATION SERVICES BUT DOES NOT AND DOES NOT INTEND TO
          PROVIDE TRANSPORTATION SERVICES OR ACT IN ANY WAY AS A TRANSPORTATION CARRIER AND HAS NO
          RESPONSIBILITY OR LIABILITY FOR ANY TRANSPORTATION SERVICES PROVIDED TO MEMBER BY SUCH
          THIRD PARTIES. AIRACER MAY INTRODUCE MEMBER TO THIRD-PARTY TRANSPORTATION PROVIDERS TO
          PROVIDE MEMBER TRANSPORTATION, BUT AIRACER DOES NOT ASSESS THE SUITABILITY, LEGALITY, OR
          ABILITY OF ANY THIRD-PARTY TRANSPORTATION PROVIDER AND MEMBER EXPRESSLY WAIVES AND
          RELEASES AIRACER FROM ANY AND ALL LIABILITY, CLAIMS, OR DAMAGES ARISING FROM OR IN ANY WAY
          RELATED TO THE THIRD-PARTY TRANSPORTATION PROVIDER. MEMBER ACKNOWLEDGES THAT AIRACER DOES
          NOT MONITOR ANY THIRD-PARTY TRANSPORTATION PROVIDER’S ON-GOING COMPLIANCE WITH ANY AND ALL
          LICENSING AND/OR PERMITTING RULES AND REGULATIONS, AND AIRACER WILL NOT BE RESPONSIBLE FOR
          ANY LIABILITY, CLAIMS, OR DAMAGES ARISING FROM OR IN ANY WAY RELATED TO A THIRD-PARTY
          TRANSPORTATION PROVIDER’S FAILURE TO MAINTAIN A CURRENT LICENSE AND/OR PERMIT.
          RESPONSIBILITY FOR THE DECISIONS MEMBER MAKES REGARDING AIRACER’S SERVICES RESTS SOLELY
          WITH MEMBER. AIRACER WILL NOT ASSESS THE SUITABILITY, LEGALITY, OR ABILITY OF ANY SUCH
          THIRD PARTIES AND MEMBER EXPRESSLY WAIVES AND RELEASES AIRACER FROM ANY AND ALL LIABILITY,
          CLAIMS, CAUSES OF ACTION, OR DAMAGES ARISING FROM MEMBER’S USE OF THE SERVICE, OR IN ANY
          WAY RELATED TO THE THIRD PARTIES INTRODUCED TO MEMBER BY THE SERVICE. IN NO EVENT WILL
          AIRACER, ITS SHAREHOLDERS, DIRECTORS, SUPPLIERS OR LICENSORS BE LIABLE FOR ANY DAMAGES
          WHATSOEVER, WHETHER DIRECT, INDIRECT, GENERAL, SPECIAL, COMPENSATORY, CONSEQUENTIAL,
          AND/OR INCIDENTAL, ARISING OUT OF OR RELATING TO THE CONDUCT OF MEMBER OR ANYONE ELSE IN
          CONNECTION WITH THE USE OF THE SERVICES, INCLUDING WITHOUT LIMITATION, DEATH, BODILY
          INJURY, EMOTIONAL DISTRESS, AND/OR ANY OTHER DAMAGES RESULTING FROM INTERACTIONS WITH
          OTHER THIRD PARTIES, THIRD-PARTY SERVICES, OR FLIGHTS MEMBER BOOKS THROUGH THE SERVICES.{' '}
          <br />
          <br />
          ANY DISPUTE MEMBER HAS WITH ANY OPERATOR, CARRIER, SERVICE PROVIDER, OR OTHER THIRD PARTY,
          INCLUDING, WITHOUT LIMITATION, ANY OTHER USER OF THE SERVICE, IS DIRECTLY BETWEEN MEMBER
          AND SUCH THIRD PARTY AND MEMBER IRREVOCABLY RELEASES AIRACER AND ITS MEMBERS, AFFILIATES,
          AGENTS, SUBSIDIARIES, JOINT VENTURES AND EMPLOYEES) FROM ANY AND ALL CLAIMS, DEMANDS AND
          DAMAGES (ACTUAL AND CONSEQUENTIAL) OF EVERY KIND AND NATURE, KNOWN AND UNKNOWN, ARISING
          OUT OF OR IN ANY WAY CONNECTED WITH SUCH DISPUTES. AIRACER WILL NOT BE A PARTY TO DISPUTES
          OR NEGOTIATIONS OF DISPUTES BETWEEN MEMBER AND ANY THIRD-PARTY. THE QUALITY OF THE FLIGHTS
          SCHEDULED THROUGH THE SERVICES ARE ENTIRELY THE RESPONSIBILITY OF THE THIRD-PARTY PROVIDER
          WHO ULTIMATELY PROVIDES SUCH FLIGHTS OR THIRD-PARTY SERVICES. MEMBER UNDERSTAND THAT BY
          USING THE SERVICES, MEMBER MAY BE EXPOSED TO TRANSPORTATION THAT IS POTENTIALLY DANGEROUS,
          HARMFUL, OR OTHERWISE UNSAFE AND THAT MEMBER USES THE SERVICE AT MEMBER AT THEIR OWN RISK.{' '}
          <br />
          <br />
          <span>INDEMNIFICATION:</span> Member shall indemnify Airacer, its parents, subsidiaries
          and other affiliates and each of their respective officers, directors, employees, agents,
          successors and assigns (an “<b>Indemnified Party</b>”) and save and hold each of them
          harmless against and pay on behalf of or reimburse any such Indemnified Party as and when
          incurred for any losses (including attorneys’ fees) which such indemnified party may
          suffer, sustain or become subject to, as a result of, in connection with, relating or
          incidental to or by virtue to any third-party services received in connection with this
          Agreement. The provisions of this paragraph shall survive the termination of this
          Agreement and Member’s membership. <br />
          <br />
          <span>FORCE MAJEURE:</span> Airacer shall not be liable for any delay or failure to
          perform resulting from causes outside of its reasonable control, including without
          limitation any failure to perform hereunder due to unforeseen circumstances or cause
          beyond Airacer’s control such as acts of God, war, terrorism, riots, embargoes, acts of
          civil or military authorities, pandemic, epidemic, government regulations, fire, floods,
          accidents, network infrastructure failures, strikes, or shortages of transportation
          facilities, fuel, energy, labor or materials. <br />
          <br />
          <span>DISPUTE RESOLUTION:</span> <br />
          (a) <b>Mandatory Arbitration.</b> Please read this dispute resolution carefully (“
          <b>Dispute Resolution</b>”). It affects your rights. YOU AND AIRACER AND EACH OF OUR
          RESPECTIVE SUBSIDIARIES, AFFILIATES, PREDECESSORS IN INTEREST, SUCCESSORS, AND PERMITTED
          ASSIGNS AGREE TO ARBITRATION (EXCEPT FOR MATTERS THAT MAY BE TAKEN TO SMALL CLAIMS COURT),
          AS THE EXCLUSIVE FORM OF DISPUTE RESOLUTION EXCEPT AS PROVIDED FOR BELOW, FOR ALL DISPUTES
          AND CLAIMS ARISING OUT OF OR RELATING TO THIS AGREEMENT OR YOUR USE OF THE SERVICE.
          Arbitration is more informal than a lawsuit in court. Arbitration uses a neutral
          arbitrator instead of a judge or jury, allows for more limited discovery than in court,
          and is subject to very limited review by courts. Arbitrators can award the same damages
          and relief that a court can award. <br />
          <br />
          (b) <b>Procedure.</b> A party who intends to seek arbitration must first send to the
          other, by certified mail, a written notice of intent to arbitrate (a <b>“Notice”</b>), or,
          in the absence of a mailing address provided by you to Airacer, to you via any other
          method available to Airacer, including via e-mail. The Notice to Airacer should be
          addressed to AIRACER INC. 560 Lexington Ave, New York, NY 10022, Attn: General
          Counsel (the <b>“Arbitration Notice Address”</b>). The Notice must (A) describe the nature
          and basis of the claim or dispute; and (B) set forth the specific relief sought (the{' '}
          <b>“Demand”</b>). If you and Airacer do not reach an agreement to resolve the claim within
          30 days after the Notice is received, you or Airacer may commence an arbitration
          proceeding as set forth below or file a claim in small claims court. THE ARBITRATION WILL
          BE ADMINISTERED BY THE AMERICAN ARBITRATION ASSOCIATION (<b>“AAA”</b>) IN ACCORDANCE WITH
          ITS COMMERCIAL ARBITRATION RULES AND THE SUPPLEMENTARY PROCEDURES FOR CONSUMER RELATED
          DISPUTES (the <b>“Rules”</b>), AS MODIFIED BY THIS AGREEMENT. The Rules and AAA forms are
          available online at{' '}
          <a href="https://www.adr.org/" style={{ 'text-decoration': 'underline' }}>
            www.adr.org
          </a>
          . If you are required to pay a filing fee to commence an arbitration against Airacer, then
          Airacer will promptly reimburse you for your confirmed payment of the filing fee upon
          Airacer’s receipt of Notice at the Arbitration Notice Address that you have commenced
          arbitration along with a receipt evidencing payment of the filing fee, unless your Demand
          is equal to or greater than $1,000 or was filed in bad faith, in which case you are solely
          responsible for the payment of the filing fee. <br />
          <br />
          (c) <b>Arbitration Proceeding.</b> The arbitration will be conducted in the English
          language. A single independent and impartial arbitrator will be appointed pursuant to the
          Rules, as modified herein. You and Airacer agree to comply with the following rules, which
          are intended to streamline the dispute resolution process and reduce the costs and burdens
          on the parties: (i) the arbitration will be conducted by telephone, online and/or be
          solely based on written submissions, the specific manner to be chosen by the party
          initiating the arbitration; (ii) the arbitration will not require any personal appearance
          by the parties or witnesses unless otherwise mutually agreed in writing by the parties;
          and (iii) any judgment on the award rendered by the arbitrator may be entered in any court
          of competent jurisdiction. <br />
          <br />
          (d) <b>No Class Actions.</b> YOU AND AIRACER AGREE THAT THE PARTIES MAY BRING CLAIMS
          AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT AS A PLAINTIFF OR CLASS
          MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. FURTHER, YOU AGREE THAT THE
          ARBITRATOR MAY NOT CONSOLIDATE PROCEEDINGS OF MORE THAN ONE PERSON’S CLAIMS, AND MAY NOT
          OTHERWISE PRESIDE OVER ANY FORM OF A REPRESENTATIVE OR CLASS PROCEEDING, AND THAT IF THIS
          SPECIFIC PARAGRAPH IS FOUND TO BE UNENFORCEABLE, THEN THE ENTIRETY OF THIS MANDATORY
          ARBITRATION SECTION WILL BE NULL AND VOID. <br />
          <br />
          (e) <b>Decision of the Arbitrator.</b> Barring extraordinary circumstances, the arbitrator
          will issue his or her decision within 120 days from the date the arbitrator is appointed.
          The arbitrator may extend this time limit for an additional 30 days in the interests of
          justice. All arbitration proceedings will be closed to the public and confidential and all
          records relating thereto will be permanently sealed, except as necessary to obtain court
          confirmation of the arbitration award. The award of the arbitrator will be in writing and
          will include a statement setting forth the reasons for the disposition of any claim. The
          arbitrator will apply the laws of the State of New York in conducting the arbitration. You
          acknowledge that these terms and your use of the Service evidences a transaction involving
          interstate commerce. The United States Federal Arbitration Act will govern the
          interpretation, enforcement, and proceedings pursuant to the Mandatory Arbitration clause
          in this Agreement. <br />
          <br />
          (f) <b>Equitable Relief.</b> The foregoing provisions of this Dispute Resolution section
          do not apply to any claim in which Airacer seeks equitable relief of any kind. You
          acknowledge that, in the event of a breach of this Agreement by Airacer or any third
          party, the damage or harm, if any, caused to you will not entitle you to seek injunctive
          or other equitable relief against Airacer, and your only remedy will be for monetary
          damages, subject to the limitations of liability set forth in this Agreement. <br />
          <br />
          (g) <b>Claims.</b> You and Airacer agree that, notwithstanding any other rights the party
          may have under law or equity, any cause of action arising out of or related to this
          Agreement, excluding a claim for indemnification, must commence within one year after the
          cause of action accrues. Otherwise, such cause of action is permanently barred. All claims
          you bring against Airacer must be resolved in accordance with this Dispute Resolution
          section. All claims filed or brought contrary to this Dispute Resolution section will be
          considered improperly filed. Should you file a claim contrary to this Dispute Resolution
          section, Airacer may recover attorneys' fees and costs up to $5,000, provided that Airacer
          has notified you in writing of the improperly filed claim, and you have failed to promptly
          withdraw the claim. <br />
          <br />
          (h) <b>Modifications.</b> In the event that Airacer makes any future change to the
          Mandatory Arbitration provision (other than a change to Airacer’s Arbitration Notice
          Address), you may reject any such change by sending us written notice within 30 days of
          the change to Airacer’s Arbitration Notice Address, in which case your account with
          Airacer and your license to use the Service will terminate immediately, and this Dispute
          Resolution provision, as in effect immediately prior to the amendments you reject, will
          survive the termination of this Agreement. <br />
          <br />
          (i) <b>Enforceability.</b> If only Section (d) hereunder or the entirety of this Section
          10 is found to be unenforceable, then the entirety of this Arbitration provision will be
          null and void and, in such case, the parties agree that the exclusive jurisdiction and
          venue described in Section titled “Governing Law” will govern any action arising out of or
          related to this Agreement. <br />
          <br />
          <span>GOVERNING LAW:</span> The laws of the State of New York, excluding its conflicts of
          law rules, govern this Agreement. Your use of the Service may also be subject to other
          local, state, federal, or international laws. To the extent that any action relating to
          any dispute hereunder is permitted to be brought in a court of law, such action will be
          subject to the exclusive jurisdiction of the state and federal courts located in New York
          County, New York, and you hereby irrevocably submit to personal jurisdiction in such
          courts and waive any defense of inconvenient forum. <br />
          <br />
          <span>MISCELLANEOUS:</span> (i) This Agreement shall be binding upon and inure to the
          benefit of the parties hereto and their respective heirs, successors and permitted
          assigns, (ii) this Agreement constitutes the complete and exclusive understanding and
          agreement of the parties with respect to its subject matter and supersedes all prior
          understandings and agreements, whether written or oral, with respect to its subject
          matter. Any waiver, modification, or amendment of any provision of this Agreement will be
          effective only if in writing and signed by the parties hereto, and (iii) if any term or
          provision of this Agreement is declared to be illegal, invalid or unenforceable for any
          reason whatsoever by a court of competent jurisdiction, the illegality, invalidity or
          unenforceability shall not affect the validity of the remainder of this Agreement, and to
          the extent permitted by applicable laws, any such term or provision shall be restricted in
          applicability or reformed to the minimum extent for such to be enforceable. <br />
          <br />
          <span>ASSIGNMENT:</span> The Agreement and the Services provided hereunder shall not be
          assignable or transferable by Member without the prior written consent of Airacer (which
          may be withheld in Airacer’ absolute discretion). Members may not reproduce, duplicate,
          copy, sell, resell, or exploit any portion of the Services without the Airacer’s express
          prior written consent. <br />
          <br />
          <span>SIGNATURES:</span> By signing this Agreement, Member acknowledges that (a) This
          Agreement will become legally binding upon its acceptance by Airacer, and (b) Airacer
          makes no representations or warranties to Member, either expressed or implied, except to
          the extent expressly set forth in this Agreement. The Agreement and any documents pursuant
          hereto may be separately executed by the Parties in two or more counterparts, and by
          facsimile, PDF, or similar means of electronic delivery, and all such counterparts shall
          be deemed an original, but all of which together shall constitute one and the same
          instrument and will be binding on the Parties as if they had originally signed one copy of
          the Agreement. <br />
          <br />
          <b>You may contact us at:</b> <br />
          <br />
          <b>Airacer, Inc.</b> 560 Lexington Ave <br />
          <br />
          New York, NY 10022 <br />
          <br />
          <b>By Email:</b>
          <br />
          <a
            href={`mailto:${marketingEmail}`}
            style={{ 'text-decoration': 'underline', color: 'rgb(5,99,193)' }}
          >
            {marketingEmail}
          </a>{' '}
        </div>
        <Footer />
      </Fragment>
    );
  }
}
